module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_technical_text_sm-8118363a3c3474bec683d579a698d2fe.svg";